import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=29c5169f&scoped=true"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"
import style0 from "./Threads.vue?vue&type=style&index=0&id=29c5169f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c5169f",
  null
  
)

export default component.exports